import {
    GET_SERVICES , SET_SERVICES , ACTIVE_SERVICE ,MARK_ACTIVE_SERVICE
} from "@/core/store/modules/services/constants";
import api from "@/core/services/api/api.service";
 export default {
    [GET_SERVICES](context) {
        if (context.getters.isAuthenticated) {
            return new Promise((resolve, reject) => {
                api.waiting('summary').get('/services/summary').then(response => {
                    context.commit(SET_SERVICES, response.data);
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        }
    },
    [MARK_ACTIVE_SERVICE](context, data) {
        context.commit(ACTIVE_SERVICE, data);
    }
}